import type { UiSurface } from '@yeshuman/sdk'

/** Apply canvas — cover letter and screening answers. */
export function applicationCanvasSurface(applicationId: string): UiSurface {
  return {
    intent: 'create',
    entity: 'application',
    id: applicationId,
    mode: 'canvas',
    fields: ['cover_letter', 'answers'],
  }
}

export function opportunityCanvasSurface(
  opportunityId: string,
  fields: string[],
  intent: 'create' | 'edit' = 'edit',
): UiSurface {
  return {
    intent,
    entity: 'opportunity',
    id: opportunityId,
    mode: 'canvas',
    fields,
  }
}

export const JOB_DESCRIPTION_CANVAS_FIELDS = ['description'] as const
export const JOB_CREATE_CANVAS_FIELDS = ['title', 'description'] as const
export const JOB_DETAILS_CANVAS_FIELDS = ['title'] as const
export const JOB_SKILLS_CANVAS_FIELDS = ['add_skills', 'remove_skills'] as const
